import React from 'react';
import './CustomSelect.css';
import IconFR from './icons/iconFR.svg';
import IconEN from './icons/iconEN.svg';
import IconDE from './icons/iconDE.svg';
import ArrowGreen from './icons/arrow-green.svg';
const { useState } = React;

// the selected language on page load is the language of the page. 0-FR, 1-EN, 2-DE
function getPageLanguage() {
  const currentLang =
    document.querySelector('#switch-current')?.innerHTML || 'en';
  return currentLang === 'de' ? 2 : currentLang === 'en' ? 1 : 0;
}

function getLanguageFromIndex(index: number) {
  return index === 2 ? 'de' : index === 1 ? 'en' : 'fr';
}

const CustomSelect = () => {
  const [isOptionsOpen, setIsOptionsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(getPageLanguage());
  const [buttonLang, setButtonLang] = useState(
    getLanguageFromIndex(selectedOption)
  );

  const optionsList = ['Français', 'English', 'Deutsch'];
  const imagesList = [IconFR, IconEN, IconDE];

  const toggleOptions = () => {
    setIsOptionsOpen(!isOptionsOpen);
  };

  const setSelectedThenCloseDropdown = index => {
    setButtonLang(getLanguageFromIndex(index));
    setSelectedOption(index);
    setIsOptionsOpen(false);
  };

  const handleKeyDown = index => e => {
    switch (e.key) {
      case ' ':
      case 'SpaceBar':
      case 'Enter':
        e.preventDefault();
        setSelectedThenCloseDropdown(index);
        break;
      default:
        break;
    }
  };

  const handleListKeyDown = e => {
    switch (e.key) {
      case 'Escape':
        e.preventDefault();
        setIsOptionsOpen(false);
        break;
      case 'ArrowUp':
        e.preventDefault();
        setSelectedOption(
          selectedOption - 1 >= 0 ? selectedOption - 1 : optionsList.length - 1
        );
        break;
      case 'ArrowDown':
        e.preventDefault();
        setSelectedOption(
          selectedOption === optionsList.length - 1 ? 0 : selectedOption + 1
        );
        break;
      default:
        break;
    }
  };

  return (
    <div className="wrapper-custom-select">
      <div className="container-custom-select">
        <button
          lang={buttonLang}
          type="button"
          aria-haspopup="listbox"
          aria-expanded={isOptionsOpen}
          className={isOptionsOpen ? 'expanded' : ''}
          onClick={toggleOptions}
          onKeyDown={handleListKeyDown}
        >
          <img
            className="icon-language"
            src={imagesList[selectedOption]}
            alt=""
          />
          {optionsList[selectedOption]}
          <img className="arrow-green" src={ArrowGreen} alt="" />
        </button>
        <ul
          className={`options ${isOptionsOpen ? 'show' : ''}`}
          role="listbox"
          aria-activedescendant={optionsList[selectedOption]}
          tabIndex={-1}
          onKeyDown={handleListKeyDown}
        >
          {optionsList.map((option, index) => (
            <li
              id={getLanguageFromIndex(index)}
              role="option"
              aria-selected={selectedOption === index}
              tabIndex={0}
              onKeyDown={handleKeyDown(index)}
              onClick={() => {
                setSelectedThenCloseDropdown(index);
                document
                  .getElementById('btn-dl-pdf')
                  ?.setAttribute('lang', getLanguageFromIndex(index));
              }}
            >
              <img className="icon-language" src={imagesList[index]} alt="" />
              {option}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default CustomSelect;
